import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["__scopeInformerModal"],
  _excluded2 = ["children"],
  _excluded3 = ["className", "children"],
  _excluded4 = ["__scopeInformerModal"],
  _excluded5 = ["__scopeInformerModal"],
  _excluded6 = ["__scopeInformerModal", "asChild"],
  _excluded7 = ["__scopeInformerModal", "asChild"],
  _excluded8 = ["size"],
  _excluded9 = ["__scopeInformerModal"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { Button } from '../../../button';
import { DialogDescription as HeadlessDialogDescription, DialogTitle as HeadlessDialogTitle } from '../../../headless/dialog';
import { createDialogScope } from '../../../headless/dialog/context';
import { DomPrimitive } from '../../../internal/components/DomPrimitive';
import { Slot } from '../../../internal/components/Slot';
import { createContextScope } from '../../../internal/context/scoped-context';
import { useComposedRefs } from '../../../internal/hooks/useComposedRefs';
import { composeEventHandlers } from '../../../internal/utils/composeEventHandlers';
import { ActionLink } from '../../../link';
import { ArticleHeading2, ArticleParagraph1 } from '../../../typography';
import { ModalClose, ModalCloseButton, ModalContent, ModalFooter, ModalRoot, ModalTrigger } from '../Modal';
import * as commonModalStyles from '../Modal/Modal.module.css';
import * as inforerModalStyles from './InformerModal.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
var ROOT_NAME = 'InformerModal';
var BODY_NAME = 'InformerModalBody';
var TITLE_NAME = 'InformerModalTitle';
var CONTENT_NAME = 'InformerModalContent';
var ACTIONS_NAME = 'InformerModalActions';
var ACTION_NAME = 'InformerModalAction';
var ACTION_SECONDARY_NAME = 'InformerModalCancel';
var MEDIA_NAME = 'InformerModalMedia';

/**
 * создаем отдельный скоуп для InformerModal
 * чтобы избежать ошибок композиции контекстов с другими модальными окнами
 */

var _createContextScope = createContextScope(ROOT_NAME, [createDialogScope]),
  _createContextScope2 = _slicedToArray(_createContextScope, 2),
  createInformerModalContext = _createContextScope2[0],
  createInformerModalScope = _createContextScope2[1];
var useDialogScope = createDialogScope();
var _createInformerModalC = createInformerModalContext(CONTENT_NAME),
  _createInformerModalC2 = _slicedToArray(_createInformerModalC, 2),
  InformerModalContentProvider = _createInformerModalC2[0],
  useInformerModalContentContext = _createInformerModalC2[1];

/**
 * HOC для оборачивания компонентов Dialog в скоуп InformerModal
 * при необходимости расширения функциональности, можно создать отдельные компонеты, см InformerModalContent
 */
var withInformerModalScope = function withInformerModalScope(Component) {
  var WrappedComponent = function WrappedComponent(props) {
    var __scopeInformerModal = props.__scopeInformerModal,
      restProps = _objectWithoutProperties(props, _excluded);
    var dialogScope = useDialogScope(__scopeInformerModal);
    return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, dialogScope), restProps));
  };
  WrappedComponent.displayName = "Informer(".concat(Component.displayName || Component.name, ")");
  return WrappedComponent;
};

/**
 * Копоненты Dialog без изменения функционала, обернутые в скоуп InformerModal
 */
export var InformerModalRoot = withInformerModalScope(ModalRoot);
export var InformerModalTrigger = withInformerModalScope(ModalTrigger);
export var InformerModalClose = withInformerModalScope(ModalClose);
export var InformerModalCloseButton = withInformerModalScope(ModalCloseButton);
export var InformerModalFooter = withInformerModalScope(ModalFooter);

/**
 * Компонент для рендера тела модального окна
 */

export var InformerModalBody = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded2);
  return /*#__PURE__*/_jsx(DomPrimitive.div, _objectSpread(_objectSpread({
    className: inforerModalStyles['body']
  }, rest), {}, {
    ref: ref,
    children: children
  }));
});
InformerModalBody.displayName = BODY_NAME;

/**
 * Компонент для рендера контейнера медиа-изображения в заголовке модального окна
 */

export var InformerModalMedia = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded3);
  return /*#__PURE__*/_jsx(DomPrimitive.div, _objectSpread(_objectSpread({
    className: clsx(inforerModalStyles['image'], className)
  }, rest), {}, {
    ref: ref,
    children: children
  }));
});
InformerModalMedia.displayName = MEDIA_NAME;

/**
 * Компонент для рендера заголовка модального окна
 */

export var InformerModalTitle = /*#__PURE__*/React.forwardRef(function (_ref3, forwardedRef) {
  var __scopeInformerModal = _ref3.__scopeInformerModal,
    rest = _objectWithoutProperties(_ref3, _excluded4);
  var dialogScope = useDialogScope(__scopeInformerModal);
  return /*#__PURE__*/_jsx(DomPrimitive.div, {
    className: clsx(commonModalStyles['title'], inforerModalStyles['title']),
    children: /*#__PURE__*/_jsx(HeadlessDialogTitle, _objectSpread(_objectSpread({}, dialogScope), {}, {
      asChild: true,
      children: /*#__PURE__*/_jsx(ArticleHeading2, _objectSpread(_objectSpread({
        textAlign: "center"
      }, rest), {}, {
        ref: forwardedRef
      }))
    }))
  });
});
InformerModalTitle.displayName = TITLE_NAME;

/**
 * Компонент для рендера описания модального окна
 * описание может использоваться как в заголовке так и в теле модального окна
 */

export var InformerModalDescription = /*#__PURE__*/React.forwardRef(function (_ref4, forwardedRef) {
  var __scopeInformerModal = _ref4.__scopeInformerModal,
    props = _objectWithoutProperties(_ref4, _excluded5);
  var dialogScope = useDialogScope(__scopeInformerModal);
  return /*#__PURE__*/_jsx(DomPrimitive.div, {
    className: clsx(commonModalStyles['description'], inforerModalStyles['description']),
    children: /*#__PURE__*/_jsx(HeadlessDialogDescription, _objectSpread(_objectSpread({}, dialogScope), {}, {
      asChild: true,
      children: /*#__PURE__*/_jsx(ArticleParagraph1, _objectSpread(_objectSpread({
        textAlign: "center",
        color: "text-secondary-default"
      }, props), {}, {
        ref: forwardedRef
      }))
    }))
  });
});
InformerModalDescription.displayName = 'InformerModalDescription';

/**
 * Компонент обертка InformerModalActions
 * используется для правильного позиционирования кнопок действия
 * @example
 * <InformerModalActions>
 *  <InformerModalCancel>Отмена</InformerModalCancel>
 *  <InformerModalAction>Принять</InformerModalAction>
 * </InformerModalActions>
 */

export var InformerModalActions = /*#__PURE__*/React.forwardRef(function (_ref5, forwardedRef) {
  var children = _ref5.children;
  return /*#__PURE__*/_jsx(DomPrimitive.div, {
    ref: forwardedRef,
    className: inforerModalStyles['actions'],
    children: children
  });
});
InformerModalActions.displayName = ACTIONS_NAME;

/**
 * Button-like компонент для основного действия в модальном окне
 */

export var InformerModalAction = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var __scopeInformerModal = props.__scopeInformerModal,
    asChild = props.asChild,
    rest = _objectWithoutProperties(props, _excluded6);
  var _useInformerModalCont = useInformerModalContentContext(ACTION_SECONDARY_NAME, __scopeInformerModal),
    actionRef = _useInformerModalCont.actionRef;
  var dialogScope = useDialogScope(__scopeInformerModal);
  var ref = useComposedRefs(forwardedRef, actionRef);
  var Comp = asChild ? Slot : Button;
  return /*#__PURE__*/_jsx(ModalClose, _objectSpread(_objectSpread({
    asChild: true
  }, dialogScope), {}, {
    children: /*#__PURE__*/_jsx(Comp, _objectSpread(_objectSpread({
      size: "L"
    }, rest), {}, {
      ref: ref
    }))
  }));
});
InformerModalAction.displayName = ACTION_NAME;

/**
 * Button-like компонент для доп действия в модальном окне
 */

export var InformerModalActionSecondary = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var __scopeInformerModal = props.__scopeInformerModal,
    asChild = props.asChild,
    rest = _objectWithoutProperties(props, _excluded7);
  var dialogScope = useDialogScope(__scopeInformerModal);
  var Comp = asChild ? Slot : ActionLink;
  return /*#__PURE__*/_jsx("div", {
    className: inforerModalStyles['action-secondary'],
    children: /*#__PURE__*/_jsx(ModalClose, _objectSpread(_objectSpread({
      asChild: true
    }, dialogScope), {}, {
      children: /*#__PURE__*/_jsx(Comp, _objectSpread(_objectSpread({}, rest), {}, {
        ref: forwardedRef
      }))
    }))
  });
});
InformerModalActionSecondary.displayName = ACTION_SECONDARY_NAME;
export var InformerModalContent = /*#__PURE__*/React.forwardRef(function (_ref6, forwardedRef) {
  var _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? 'S' : _ref6$size,
    props = _objectWithoutProperties(_ref6, _excluded8);
  var __scopeInformerModal = props.__scopeInformerModal,
    contentProps = _objectWithoutProperties(props, _excluded9);
  var dialogScope = useDialogScope(__scopeInformerModal);
  var actionRef = React.useRef(null);
  /**
   * При открытии фокусируемся на кнопке основного действия по умолчанию
   */
  var handleOnOpenAutoFocus = React.useMemo(function () {
    return composeEventHandlers(contentProps.onOpenAutoFocus, function (event) {
      var _actionRef$current;
      event.preventDefault();
      (_actionRef$current = actionRef.current) === null || _actionRef$current === void 0 || _actionRef$current.focus({
        preventScroll: true
      });
    });
  }, [contentProps.onOpenAutoFocus]);
  return /*#__PURE__*/_jsx(InformerModalContentProvider, {
    actionRef: actionRef,
    scope: __scopeInformerModal,
    children: /*#__PURE__*/_jsx(ModalContent, _objectSpread(_objectSpread(_objectSpread({}, dialogScope), contentProps), {}, {
      size: size,
      portalProps: dialogScope,
      overlayProps: dialogScope,
      onOpenAutoFocus: handleOnOpenAutoFocus,
      ref: forwardedRef
    }))
  });
});
InformerModalContent.displayName = CONTENT_NAME;
export { createInformerModalScope };